import React, { ComponentProps } from 'react'
import SimpleBar from 'simplebar-react'
import { cn } from 'utils/cn'

interface ScrollBarWrapperProps {
	children: React.ReactNode
	className?: string
	style?: React.CSSProperties
	childrenClassNames?: string
	scrollbarMinSize?: number
	scrollbarMaxSize?: number
	forceVisible?: ComponentProps<typeof SimpleBar>['forceVisible']
	autoHide?: boolean
	clickOnTrack?: boolean
	isRtl?: boolean
	scrollableNodeProps?: ComponentProps<typeof SimpleBar>['scrollableNodeProps']
}

const ScrollBarWrapper = ({
	children,
	className,
	style,
	childrenClassNames,
	scrollbarMinSize,
	scrollbarMaxSize,
	forceVisible = 'y',
	autoHide = false,
	clickOnTrack = true,
	isRtl = false,
	scrollableNodeProps,
}: ScrollBarWrapperProps) => {
	return (
		<SimpleBar
			className={cn(className, 'relative', isRtl ? 'rtl' : 'ltr')}
			autoHide={autoHide}
			forceVisible={forceVisible}
			clickOnTrack={clickOnTrack}
			style={style}
			scrollbarMinSize={scrollbarMinSize}
			scrollbarMaxSize={scrollbarMaxSize}
			data-simplebar-direction={isRtl ? 'rtl' : 'ltr'}
			scrollableNodeProps={{
				style: {
					...scrollableNodeProps?.style,
				},
				...scrollableNodeProps,
			}}
		>
			<div className={childrenClassNames}>{children}</div>
		</SimpleBar>
	)
}

export { ScrollBarWrapper }
